export default __webpack_public_path__ + "static/img-3-a921b5b874b80b5d6303e539ebe59cdc.png";